/* eslint-disable no-restricted-globals */
// ─────────────────────────────────────────────────────────────────────────
// SERGA // PERSONAL OS — view-state store
// View *selections* (which period / tab / filter the user is looking at) live
// HERE, in their own namespace — never on the data objects in data.js. That is
// the rule the healthy selections already follow (SONIC tab, FEED collapse,
// CONFIG): keep selection off the data object so neither a setLive* data swap
// nor a reload can clobber it. Persisted to localStorage so a selection
// survives a refresh AND a live data refresh until the user changes it.
//
// Usage: getView('invest.period', '1M') / setView('invest.period', '1D').
// Any future selection (budget month, CAPTURE filter, VITALS sub-view) opts in
// with its own key — no per-feature plumbing.
// ─────────────────────────────────────────────────────────────────────────
const KEY = 'serga-os-view';

let state = {};
try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { state = {}; }

const save = () => { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} };

// Read a view selection, falling back to `def` (the fallback is NOT persisted —
// only an explicit setView writes, so the default can evolve in code freely).
export function getView(key, def) {
  return Object.prototype.hasOwnProperty.call(state, key) ? state[key] : def;
}

// Set + persist a view selection.
export function setView(key, val) {
  state[key] = val;
  save();
}
